export function getImageUrl(encodedId) {
  const baseUrl = window.REACT_APP_API_URL || process.env.REACT_APP_BASE_URL_JAVA;
  return `${baseUrl}/api/public/images/${encodedId}`;
}
